

import {store} from '../store'

import {mapActions, mapGetters} from 'vuex';


import TopicsSelect from '../vue_components/TopicsSelect.vue'
import MultiSelect from '../vue_components/MultiSelect.vue'
import DatePicker from 'vue2-datepicker'

let localeText = {
    url: process.env.NODE_ENV !== 'production' ? 'staticText/myInfoPage.json' : 'staticText',
    main: {
        otherTitle: "Перед созданием нового урока",
        otherTitle_1: "Заполните профиль",
        otherDescription: "Чтобы процесс обучения строился более качественно и комфортно для учеников, нам нужно знать о вас немного больше. Это даст лучшее понимание кто ведёт занятие и сделает выбор учителя более простым и осознанным. Вы сможете создавать уроки после заполнения полей ниже, а информация в личном кабинете обновится — вам не придётся самостоятельно вносить изменения заново.", 
        otherTitle_2: "Чтобы создавать уроки, обновите личные данные",
        imageTitle: "Фотография",
        imageMust: "Пожалуйста, загрузите фотографию",
        infoImg: 'Рекомендуем предварительно подготовить фотографию: размер 256×256 пикселей, форматы jpg, png',
        uploadImg: "Загрузить изображение",
        saveImg: "Изменить",
        deleteImg: "Удалить",
        title_1: "Информация",
        fio: "Ваше имя, фамилия и отчество",
        birdthDay: "Дата рождения",
        location: "Местоположение",
        locationNoOptions: "Начните вводить свой город.",
        timeZone: "Часовой пояс",
        language: "Язык обучения",
        // knowledge: "Интересующие области знаний",
        topics: "Интересующие темы",
        about: "О себе",
        education: "Образование",
        experience: "Опыт работы",
        video: "Видео",
        uploadBtn: "Загрузить",
        newContacts: "Новый контакт",
        addContacts: "Добавить контакт",
        updateBtn: "Изменить",
        saveBtn: "Сохранить",
        cancelBtn: "Отменить изменения",
        contacts: "Контакты",
        formVideoTitle: "Ссылка",
        formVideoPlaceholder: "Ссылка на видео с youtube или vimeo",
        formVideoError: "Неверная ссылка. Приминаются ссылки только на youtube или vimeo",
        formLastNameTitle: "Фамилия",
        formNameTitle: "Имя",
        formPatronymicTitle: "Отчество",
        empty: "Не указано",
        msgAvatarAdd: "Аватар успешно изменен",
        msgAvatarDelete: "Аватар успешно удален",
        msgInfoUpdate: "Информация обновлена",
        msgContactsUpdate: "Контакты обновлены",
        main: "Предпочтительный",
        admin: "Только для администрации",
        activeLoad: "Активные загрузки",
        stack: "В очереди",
        loadBtn: "Загрузить файлы",
        must: "Поле не заполнено"
    }
};
import VImageInput from 'vuetify-image-input';

export default {
    components: {
        'cmp-topics-select': TopicsSelect,
        DatePicker,
        'cmp-multi-select': MultiSelect,
        [VImageInput.name]: VImageInput,
        // 'cmp-documents': Documents
    },

    data() {
        return {
            editImage: false,
            imageData: "",
            // imageData: "data:image/gif;base64,R0lGODlhPQBEAPeoAJosM//AwO/AwHVYZ/z595kzAP/s7P+goOXMv8+fhw/v739/f+8PD98fH/8mJl+fn/9ZWb8/PzWlwv///6wWGbImAPgTEMImIN9gUFCEm/gDALULDN8PAD6atYdCTX9gUNKlj8wZAKUsAOzZz+UMAOsJAP/Z2ccMDA8PD/95eX5NWvsJCOVNQPtfX/8zM8+QePLl38MGBr8JCP+zs9myn/8GBqwpAP/GxgwJCPny78lzYLgjAJ8vAP9fX/+MjMUcAN8zM/9wcM8ZGcATEL+QePdZWf/29uc/P9cmJu9MTDImIN+/r7+/vz8/P8VNQGNugV8AAF9fX8swMNgTAFlDOICAgPNSUnNWSMQ5MBAQEJE3QPIGAM9AQMqGcG9vb6MhJsEdGM8vLx8fH98AANIWAMuQeL8fABkTEPPQ0OM5OSYdGFl5jo+Pj/+pqcsTE78wMFNGQLYmID4dGPvd3UBAQJmTkP+8vH9QUK+vr8ZWSHpzcJMmILdwcLOGcHRQUHxwcK9PT9DQ0O/v70w5MLypoG8wKOuwsP/g4P/Q0IcwKEswKMl8aJ9fX2xjdOtGRs/Pz+Dg4GImIP8gIH0sKEAwKKmTiKZ8aB/f39Wsl+LFt8dgUE9PT5x5aHBwcP+AgP+WltdgYMyZfyywz78AAAAAAAD///8AAP9mZv///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAKgALAAAAAA9AEQAAAj/AFEJHEiwoMGDCBMqXMiwocAbBww4nEhxoYkUpzJGrMixogkfGUNqlNixJEIDB0SqHGmyJSojM1bKZOmyop0gM3Oe2liTISKMOoPy7GnwY9CjIYcSRYm0aVKSLmE6nfq05QycVLPuhDrxBlCtYJUqNAq2bNWEBj6ZXRuyxZyDRtqwnXvkhACDV+euTeJm1Ki7A73qNWtFiF+/gA95Gly2CJLDhwEHMOUAAuOpLYDEgBxZ4GRTlC1fDnpkM+fOqD6DDj1aZpITp0dtGCDhr+fVuCu3zlg49ijaokTZTo27uG7Gjn2P+hI8+PDPERoUB318bWbfAJ5sUNFcuGRTYUqV/3ogfXp1rWlMc6awJjiAAd2fm4ogXjz56aypOoIde4OE5u/F9x199dlXnnGiHZWEYbGpsAEA3QXYnHwEFliKAgswgJ8LPeiUXGwedCAKABACCN+EA1pYIIYaFlcDhytd51sGAJbo3onOpajiihlO92KHGaUXGwWjUBChjSPiWJuOO/LYIm4v1tXfE6J4gCSJEZ7YgRYUNrkji9P55sF/ogxw5ZkSqIDaZBV6aSGYq/lGZplndkckZ98xoICbTcIJGQAZcNmdmUc210hs35nCyJ58fgmIKX5RQGOZowxaZwYA+JaoKQwswGijBV4C6SiTUmpphMspJx9unX4KaimjDv9aaXOEBteBqmuuxgEHoLX6Kqx+yXqqBANsgCtit4FWQAEkrNbpq7HSOmtwag5w57GrmlJBASEU18ADjUYb3ADTinIttsgSB1oJFfA63bduimuqKB1keqwUhoCSK374wbujvOSu4QG6UvxBRydcpKsav++Ca6G8A6Pr1x2kVMyHwsVxUALDq/krnrhPSOzXG1lUTIoffqGR7Goi2MAxbv6O2kEG56I7CSlRsEFKFVyovDJoIRTg7sugNRDGqCJzJgcKE0ywc0ELm6KBCCJo8DIPFeCWNGcyqNFE06ToAfV0HBRgxsvLThHn1oddQMrXj5DyAQgjEHSAJMWZwS3HPxT/QMbabI/iBCliMLEJKX2EEkomBAUCxRi42VDADxyTYDVogV+wSChqmKxEKCDAYFDFj4OmwbY7bDGdBhtrnTQYOigeChUmc1K3QTnAUfEgGFgAWt88hKA6aCRIXhxnQ1yg3BCayK44EWdkUQcBByEQChFXfCB776aQsG0BIlQgQgE8qO26X1h8cEUep8ngRBnOy74E9QgRgEAC8SvOfQkh7FDBDmS43PmGoIiKUUEGkMEC/PJHgxw0xH74yx/3XnaYRJgMB8obxQW6kL9QYEJ0FIFgByfIL7/IQAlvQwEpnAC7DtLNJCKUoO/w45c44GwCXiAFB/OXAATQryUxdN4LfFiwgjCNYg+kYMIEFkCKDs6PKAIJouyGWMS1FSKJOMRB/BoIxYJIUXFUxNwoIkEKPAgCBZSQHQ1A2EWDfDEUVLyADj5AChSIQW6gu10bE/JG2VnCZGfo4R4d0sdQoBAHhPjhIB94v/wRoRKQWGRHgrhGSQJxCS+0pCZbEhAAOw==",
            pageTextInfo: {},
            form_contacts: [],
            form_info: [
                {
                    type: 'text',
                    name: 'name',
                    title: '',
                    value: '',
                    placeholder: '',
                    error: false,
                    class: '',
                    pattern: /^[а-яА-Яa-zA-Z-' ]{2,30}$/,
                    required: true
                },
                {
                    type: 'text',
                    name: 'patronymic',
                    title: '',
                    value: '',
                    placeholder: '',
                    error: false,
                    class: '',
                    pattern: /^[а-яА-Яa-zA-Z-' ]{2,30}$/,
                    required: false
                },
                {
                    type: 'text',
                    name: 'last_name',
                    title: '',
                    value: '',
                    placeholder: '',
                    error: false,
                    class: '',
                    pattern: /^[а-яА-Яa-zA-Z-' ]{2,30}$/,
                    required: true
                },
                {
                    type: 'date',
                    name: 'birth_day',
                    title: '',
                    value: '',
                    placeholder: '',
                    error: false,
                    class: '',
                    pattern: /^[0-9/.]+$/,
                    required: false
                },
                {
                    type: 'select',
                    name: 'location',
                    searchable: true,
                    title: '',
                    value: '',
                    options: [],
                    placeholder: '',
                    error: false,
                    class: '',
                    pattern: '',
                    required: false
                },
                {
                    type: 'select',
                    name: 'time_zone',
                    searchable: false,
                    title: '',
                    value: [],
                    options: store.getters['handbook/time_zone'],
                    placeholder: '',
                    error: false,
                    class: '',
                    pattern: '',
                    required: true
                },
                {
                    type: 'select_multi',
                    name: 'language',
                    searchable: false,
                    title: '',
                    value: [],
                    options: store.getters['handbook/languages'],
                    placeholder: '',
                    error: false,
                    class: '',
                    pattern: '',
                    required: true
                },
                {
                    type: 'topics_select',
                    name: 'topics',
                    title: '',
                    value: [],
                    options: store.getters['handbook/topics'],
                    placeholder: '',
                    error: false,
                    class: 't-input_70',
                    pattern: '',
                    required: true
                },
                {
                    type: 'textarea',
                    name: 'about',
                    title: '',
                    value: '',
                    placeholder: 'Расскажите немного о себе',
                    error: false,
                    class: '',
                    pattern: '',
                    required: true
                },
                {
                    type: 'textarea',
                    name: 'education',
                    title: '',
                    value: '',
                    placeholder: 'Расскажите немного о своем образовании',
                    error: false,
                    class: '',
                    pattern: '',
                    required: true
                },
                {
                    type: 'textarea',
                    name: 'experience',
                    title: '',
                    value: '',
                    placeholder: 'Расскажите немного о своем опыте работы',
                    error: false,
                    class: '',
                    pattern: '',
                    required: true
                }
            ]
        }
    },
    computed: {
        ...mapGetters('profile', ['user']),
        ...mapGetters('handbook', ['contactsType']),
        canSave(){
            for (let i = 0; i < this.form_info.length; i++) {
                if (this.form_info[i].type == 'topics_select' || this.form_info[i].type == 'select_multi' || this.form_info[i].type == 'select') {
                    if (this.form_info[i].required  &&  (this.form_info[i].value && this.form_info[i].value.length == 0)) {
                        return false
                    }
                } else if (this.form_info[i].type == 'text' || this.form_info[i].type == 'textarea') {
                    if (this.form_info[i].required  && (this.form_info[i].value == '' || this.form_info[i].value == null)) {
                        return false
                    }
                } else if (typeof this.form_info[i].value === 'object') {
                    if (this.form_info[i].required  && !this.form_info[i].value) {
                        return false
                    }
                } else {
                    if (this.form_info[i].required  &&  (this.form_info[i].value == '' || this.form_info[i].value == null ) ){
                        return false
                    }
                }
            }
            return true
        },
        canSaveImg(){
            if (this.user.img == ''){
                if (this.editImage) {
                    return true
                } else {
                    return false;
                }
            }
            return true
        },
        canSaveContacts(){
            let hasEmail = false;
            if (this.form_contacts.length > 0 ){
                this.form_contacts.some(item => {
                    if (item.title == 'Email' && item.value != ''){
                        hasEmail = true;
                        return true;
                    }
                    return false;
                })
            }
            if (!hasEmail){
                return false;
            }
            return true
        },
        // changeFoem(){
        //     for (let i = 0; i < this.form_info.length; i++) {
        //         if (this.form_info[i].value != user[this.form_info[i].name]) {
        //             return true
        //         }
        //     }
        //     return false
        // },
    },
    methods: {
        ...mapActions('profile', ['updateAvatar', 'LoadUserInfo', 'updateVideo', 'updateContacts']),
        ...mapActions('msg', ['showMsg', 'showMsgObj']),
        DelAvatar() {
            if (this.editImage ){
                this.editImage = false;
                this.imageData = undefined;
            } else {
                this.$http.delete('profile/avatar')
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        this.updateAvatar('');
                        this.showMsg(this.pageTextInfo.msgAvatarDelete)
                    } else {
                        if (data.errors && data.errors != ''){
                            this.showMsg(data.errors)
                        } else {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    }
                })
                .catch(error => {
                    this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                });
            }
        },
        yandexSearch(index, value) {
            if (value !== '' && this.form_info[index].name === 'location') {
                ymaps.load(() => {
                    ymaps.suggest(value).then(items => {
                        let result = [];

                        for (let i = 0; i < items.length; i++) {
                            result.push(items[i].value)
                        }

                        this.form_info[index].options = result;
                    });
                });
            }
        },
        updateSelect(index, e) {
            this.form_info[index].value = e;
        },
        EditImage(event){
            this.getBase64(event[0]).then((img)=>{
                this.imageData = img;
                this.editImage= true;
            });
        },
        SaveImage(){
            return new Promise((resolve, reject) =>{
                let name = Date.now();
                var file = this.getFile(this.imageData, name + '.jpeg');
                this.LoadFile([file]).then(()=>{
                    this.editImage = false;
                    this.imageData = undefined;
                    this.LoadUserInfo()
                    this.showMsg(this.pageTextInfo.msgAvatarAdd)
                    resolve();
                }, ()=>{
                    this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    reject();
                })
            })
        },
        getFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type:mime});
        },
        getBase64:
            file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            }),
        
        LoadFile(event) {
            return new Promise((resolve, reject) =>{
                let formData = new FormData();
                formData.append('photo', event[0]);
                this.$http.put('profile/avatar', formData)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            let reader = new FileReader();

                            reader.onload = (() => {
                                return (e) => {
                                    this.updateAvatar(e.target.result);
                                };
                            })(event[0]);
                            reader.readAsDataURL(event[0]);

                            resolve()
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            })
        },

        SaveInfo(fullInfo = false) {
            if (fullInfo){
                this.SaveImage().then(()=>{
                    this.SaveUserInfo().then(()=>{
                        this.SaveContactsPromise().
                            then(()=>{
                                this.LoadUserInfo().then(() => {
                                    this.showMsg(this.pageTextInfo.msgInfoUpdate)
                                });
                            }).catch(e => {});
                    });
                });
            } else {
                this.SaveUserInfo().then(()=>{
                    this.LoadUserInfo().then(() => {
                        this.showMsg(this.pageTextInfo.msgInfoUpdate)
                    });
                });
            }
        },
        SaveUserInfo(){
            return new Promise((resolve, reject) =>{
                let fd = new FormData();
                for (let i = 0; i < this.form_info.length; i++) {
                    switch (this.form_info[i].type) {
                        case 'select_multi':
                            if (this.form_info[i].value.length) {
                                for (let j = 0; j < this.form_info[i].value.length; j++) {
                                    if (this.form_info[i].value[j].value > 0)
                                        fd.append(this.form_info[i].name + '[]', this.form_info[i].value[j].value);
                                    else
                                        fd.append(this.form_info[i].name + '_new[]', this.form_info[i].value[j].label);
                                }
                            }
                            break;
                        case 'topics_select':
                            if (this.form_info[i].value.length) {
                                for (let j = 0; j < this.form_info[i].value.length; j++) {
                                    if (typeof this.form_info[i].value[j].value == "string")
                                        fd.append(this.form_info[i].name + '_new[]', '{"parent_id":"'+ this.form_info[i].value[j].value.split('-')[0] + '", "name":"'+ this.form_info[i].value[j].label+ '"}');
                                    else
                                        fd.append(this.form_info[i].name + '[]', this.form_info[i].value[j].value);
                                }
                            }
                            break;
                        default:
                            if (typeof this.form_info[i].value === 'object') {
                                if (this.form_info[i].value !== null) {
                                    if (this.form_info[i].value.value) {
                                        fd.append(this.form_info[i].name, this.form_info[i].value.value);
                                    } else {
                                        if (this.form_info[i].name === 'birth_day') {
                                            // console.log(this.form_info[i].value.toISOString());
                                            let month = (this.form_info[i].value.getMonth() + 1)
                                            month = month >= 10 ?month:'0' + month;
                                            let date = this.form_info[i].value.getFullYear() + '-' + month + '-' + this.form_info[i].value.getDate()
                                            fd.append(this.form_info[i].name, date);
                                        } else {
                                            fd.append(this.form_info[i].name, this.form_info[i].value);
                                        }
                                    }
                                }
                            } else {
                                if (this.form_info[i].value !== '') {
                                    fd.append(this.form_info[i].name, this.form_info[i].value);
                                }
                            }
                            break;
                    }
                }

                this.$http.put('update_info', fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            let fd = [];
                            for (let i = 0; i < this.form_info.length; i++) {
                                fd.push({
                                    name: this.form_info[i].name,
                                    value: this.form_info[i].value
                                })
                            }
                            this.editInfo = false;
                            resolve()
                        } else {
                            if (data.errors){
                                // data.errors.forEach((item)=>{
                                //     item.forEach((item2)=>{
                                //         this.showMsg(item2)
                                //     })
                                // })
                                this.showMsgObj(data.errors)
                            } else {
                                this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                            }
                            reject()
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        reject()
                    });
            })
        },
        DelContact(index) {
            this.form_contacts.splice(index, 1);
        },
        SetMainContact(index) {
            for (let i = 0; i < this.form_contacts.length; i++) {
                if (i !== index)
                    this.form_contacts[i].main = false;
            }
        },
        InputContact(contact){
            contact.value = contact.value.replace(/\s\s+/g, "").replace(/^\s*/,'').replace(/\s*$/,'');
            // console.log(contact.value)
        },
        FocusContact(contact){
            contact.error = false
        },
        AddContacts(e) {
            if (e) {
                let new_item = {
                    name: 'contacts[]',
                    id: e.value,
                    title: e.label,
                    value: '',
                    error: false,
                    required: false,
                    // type: e.type,
                    must: e.must
                };

                this.$set(this.form_contacts, this.form_contacts.length, new_item);
            }
        },
        SaveContacts(){
            this.SaveContactsPromise().then((response)=>{
                this.showMsg(this.pageTextInfo.msgContactsUpdate)
            }).catch(e => {

            });
        },
        SaveContactsPromise() {
            return new Promise((resolve, reject) =>{
                let fd = new FormData;
                let test = true;

                for (let i = 0; i < this.form_contacts.length; i++) {
                    if (this.form_contacts[i].value !== '') {
                        let obj = {
                            id: this.form_contacts[i].id,
                            value: this.form_contacts[i].value,
                            main: this.form_contacts[i].main,
                            admin: this.form_contacts[i].admin
                        };
                        obj = JSON.stringify(obj);
    
                        fd.append('contacts[]', obj);
                    } else {
                        this.form_contacts[i].error= true
                        test = false
                    }
                }
                if (test){
                    this.$http.put('update_contacts', fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            this.updateContacts(data.items);
                            this.editContacts = false;
                            resolve();
                        } else {
                            reject();
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        reject();
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
                } else {
                    this.showMsg('Введены пустые контакты')
                }

            })
        },
        CancelContacts() {
            for (let i = 0; i < this.user.contacts.length; i++) {
                let new_item = {
                    name: 'contacts[]',
                    id: this.user.contacts[i].id,
                    title: this.user.contacts[i].title,
                    value: this.user.contacts[i].value,
                    error: false,
                    required: false,
                    main: this.user.contacts[i].main,
                    admin: this.user.contacts[i].admin,
                    type: this.user.contacts[i].type
                };

                this.$set(this.form_contacts, this.form_contacts.length, new_item);
            }


            this.editContacts = false;
        },
        loadInfo(pageTextInfo) {
            this.pageTextInfo = pageTextInfo;

            for (let i = 0; i < this.form_info.length; i++) {
                switch (this.form_info[i].name) {
                    case 'last_name':
                        this.form_info[i].title = pageTextInfo.formLastNameTitle;
                        break;
                    case 'name':
                        this.form_info[i].title = pageTextInfo.formNameTitle;
                        break;
                    case 'patronymic':
                        this.form_info[i].title = pageTextInfo.formPatronymicTitle;
                        break;
                    case 'birth_day':
                        this.form_info[i].title = pageTextInfo.birdthDay;
                        break;
                    case 'location':
                        this.form_info[i].title = pageTextInfo.location;
                        break;
                    case 'time_zone':
                        this.form_info[i].title = pageTextInfo.timeZone;
                        break;
                    case 'language':
                        this.form_info[i].title = pageTextInfo.language;
                        break;
                    // case 'field_knowledge':
                    //     this.form_info[i].title = pageTextInfo.knowledge;
                    //     break;
                    case 'topics':
                        this.form_info[i].title = pageTextInfo.topics;
                        break;
                    case 'about':
                        this.form_info[i].title = pageTextInfo.about;
                        break;
                    case 'education':
                        this.form_info[i].title = pageTextInfo.education;
                        break;
                    case 'experience':
                        this.form_info[i].title = pageTextInfo.experience;
                        break;
                }
            }

            for (let i = 0; i < this.form_info.length; i++) {
                    this.form_info[i].value = this.user[this.form_info[i].name]?this.user[this.form_info[i].name]:'';
            }
            for (let i = 0; i < this.user.contacts.length; i++) {
                let new_item = {
                    name: 'contacts[]',
                    id: this.user.contacts[i].id,
                    title: this.user.contacts[i].title,
                    value: this.user.contacts[i].value,
                    error: false,
                    required: false,
                    main: this.user.contacts[i].main,
                    admin: this.user.contacts[i].admin,
                    type: this.user.contacts[i].type
                };
                this.$set(this.form_contacts, this.form_contacts.length, new_item);
            }
        },

    },
    // created() {
    //     this.form_contacts = [];
    // },
    beforeRouteEnter(to, from, next) {
        let pageTextInfo = {};
        let count = 0;
        store.dispatch('staticText/LoadPageText', localeText).then((data) => {
            pageTextInfo = data;
            count++;
            RunNext();
        });
        store.dispatch('handbook/LoadContactsType').then(() => {
            count++;
            RunNext();
        });
        store.dispatch('handbook/LoadLanguages', {popular: true, offset: 0, limit: 15}).then(() => {
            count++;
            RunNext();
        });
        store.dispatch('profile/LoadUserInfo').then(() => {
            count++;
            RunNext();
        });
        let RunNext = () => {
            if (count > 3){
                next(vm => vm.loadInfo(pageTextInfo))
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/vue_mixins/EditMyInfo.js